<template>
    <div class="table-list biz-unpaid">
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="house">房源地址</span>
            <span class="name">受託人</span>
            <span class="member">業務</span>
            <span class="task-date">委託時間</span>
            <span class="bonus">獎金</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-if="isLoading" class="filter-empty">
                <table-loading />
            </div>
            <div v-else-if="taskUnpaidMgtList.length != 0 && this.filterByWord == 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <!-- <button class="default-button" @click="setFilterDefault">清除篩選</button> -->
            </div>
            <div v-else-if="taskUnpaidMgtList.length == 0" class="is-empty">0 筆資料</div> 
            <ul v-else>
                <li v-for="(task,index) in filterByWord" :key="index">
                    <div class="house">
                        <div v-if="task.houseCoverImage" class="cover">
                            <img :src="imageUrl(task.houseCoverImage)" alt="">
                        </div>
                        <div v-else class="cover">
                            <img src="@/assets/img/component/houseCard/default.svg" alt="">
                        </div>
                        <div class="house-name">
                            {{task.houseName}}
                        </div>
                    </div>
                    <span class="name">{{task.taskTakerName}}</span>
                    <div class="member">{{task.agentName}}</div>
                    <span class="task-date">{{getFormatDateTime(task.taskBeginTime)}}~{{getFormatDateTime(task.taskEndTime)}}</span>
                    <span class="bonus">{{toCurrency(task.taskBonus)}}</span>
                    <span v-if="bizAuth.payTask.hasRight && task.taskStatus == 9" class="action">
                        <dot-dropmenu>
                            <ul >
                                <li @click="payment(index)">付款</li>
                            </ul>
                        </dot-dropmenu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import Modal from '@/components/widge/Modal.vue';
import VirtualAccount from '@/components/bussiness/widges/modals/virtualAccount.vue';
import ViewHouseDetail from '@/components/bussiness/widges/modals/viewHouseDetail.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';
import constant from '@/constant'
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            isLoading: true
        }
    },
    mounted () {
        this.$store.dispatch('getBizTaskUnpaidMgtList', 1)
        .then(()=>{
            this.isLoading = false
        })
    },
    watch: {
        totalPage: function (page) {
            if(page > 1){
                for (let i = 2; i <= page; i++) {
                    this.$store.dispatch('getBizTaskUnpaidMgtList', i)
                }
            }
        },
        filterByWord:{
            handler: function (val) {
                this.$store.dispatch('setBizTaskUnpaidMgtFilterResultTotal', val.length)
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        setFilterDefault: function (value) {
            this.$store.dispatch('setBizTaskProcessMgtFilterDefault')
        },
        imageUrl: function (url){
            return constant.imageUrl+url
        },
        payment: function (index) {
            let data = this.filterByWord[index]
            this.$store.dispatch('setBizTaskUnpaidMgtPaymentInfo', data)
            this.$router.push({name: 'bizTaskPayment'})
        }
    },
    computed: {
        filterByGroup: function () {
            return this.taskUnpaidMgtList.filter((item) => {
                if(this.filterQuery.group){
                    if(item.groupName == this.filterQuery.group ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterBySales: function () {
            return this.filterByGroup.filter((item) => {
                if(this.filterQuery.member){
                    if(item.salesName == this.filterQuery.member ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByBonus: function () {
            return this.filterBySales.filter((item) => {
                if( this.filterQuery.bonus ){
                    if( this.filterQuery.bonus[1] >= 100000){
                        if( this.filterQuery.bonus[0] <= item.taskBonus){
                            return item
                        }
                    }else{
                        if( this.filterQuery.bonus[0] <= item.taskBonus && this.filterQuery.bonus[1] >= item.taskBonus ){
                            return item
                        }
                    }
                    
                }else{
                    return item
                }
            });
        },
        filterByWord: function () {
            return this.filterByBonus.filter((item) => {
                if( this.filterWord ){
                    if( item.houseName.includes(this.filterWord) ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            taskUnpaidMgtList: 'GET_BIZ_TASK_UNPAID_MGT_LIST',
            totalPage: 'GET_BIZ_TASK_UNPAID_MGT_TOTAL_PAGE',
            filterQuery: 'GET_BIZ_TASK_UNPAID_MGT_FILTER_QUERY',
            filterWord: 'GET_BIZ_TASK_UNPAID_MGT_FILTER_WORD'
        })
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        Modal,
        RentSelect,
        TableSearch,
        VirtualAccount,
        ViewHouseDetail,
        tableLoading
    }
}
</script>
<style lang="scss" scoped>
    .biz-unpaid{
        .table-list-title .house,
        .table-list-body ul li .house{
            position: relative;
            width: 330px;
            margin-right: 83px;
            display: flex;
            align-items: center;
            img{
                margin-right: 16px;
            }
        }
        .table-list-title .name,
        .table-list-body ul li .name{
            width: 52px;
            margin-right: 83px;
        }
        .table-list-title .member,
        .table-list-body ul li .member{
            width: 52px;
            margin-right: 83px;
        }
        .table-list-title .task-date,
        .table-list-body ul li .task-date{
            width: 156px;
            margin-right: 83px;
        }
        .table-list-title .bonus,
        .table-list-body ul li .bonus{
            width: 43px;
            text-align: right;
            margin-right: 83px;
        }
        .table-list-body .cover{
            width: 120px;
            height: 90px;
            border-radius: 4px;
            margin-right: 16px;
            display: flex;
            align-items: center;
            border-radius: 4px;
            overflow: hidden;
            >img{
                width: 100%;
            }
        }
        .table-list-body .house-name{
            width: 170px;
            line-height: 1.5;
        }
    }
    // @media screen and (max-width: 1280px){
    //     .process{
    //         .table-list-title .cover,
    //         .table-list-body ul li .cover{
    //             margin-right: 47px;
    //         }
    //         .table-list-title .task-date,
    //         .table-list-body ul li .task-date{
    //             margin-right: 48px;
    //         }
    //         .table-list-title .house,
    //         .table-list-body ul li .house{
    //             margin-right: 49px;
    //         }
    //         .table-list-title .name,
    //         .table-list-body ul li .name{
    //             margin-right: 48px;
    //         }
    //         .table-list-title .pay-way,
    //         .table-list-body ul li .pay-way{
    //             margin-right: 49px;
    //         }
    //         .table-list-title .status,
    //         .table-list-body ul li .status{
    //             margin-right: 48px;
    //         }
    //         .table-list-title .bonus,
    //         .table-list-body ul li .bonus{
    //             margin-right: 48px;
    //         }
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/taskMgt/taskUnpaid/taskUnpaidList.vue